export enum NavItemId {
  SETTINGS = 'Settings',
  DASHBOARD = 'Sponsor Dashboard',
}

export enum NavItemType {
  SECTION = 'section',
  LINK = 'link',
}
